import { Fragment } from 'react'
import type { Color, Flower, Season } from '../../types/game'
import { assetUrl } from '../../utils/assets'
import { ResourceIcon, SeasonIcon } from '../shared/ResourceIcon'
import { Worker } from '../shared/Worker'

const SEASONS: Season[] = ['spring', 'summer', 'autumn', 'winter']

interface MobileFlowerTileProps {
  flower: Flower
  currentSeason?: Season
  pollinatedByColor?: Color | null
  onClick?: () => void
}

export function MobileFlowerTile({
  flower,
  currentSeason,
  pollinatedByColor,
  onClick,
}: MobileFlowerTileProps) {
  return (
    <div
      className={`mobile-flower-tile${flower.type === 'tree' ? ' tree' : ''}${pollinatedByColor ? ' pollinated' : ''}`}
      onClick={onClick}
    >
      <div className="mobile-flower-layout">
        <div className="mobile-flower-art">
          <img
            src={assetUrl('images', 'flowers', `${flower.name}_0.png`)}
            alt={flower.name}
            className="mobile-flower-art-img"
          />
        </div>
        <div className="mobile-flower-meta">
          <div className="mobile-flower-heading">
            <SeasonIcon
              season={flower.primary_season}
              inverted
              className="mobile-flower-season"
            />
            <div className="mobile-flower-name">{flower.name}</div>
            {flower.qualities.length ? (
              <div className="mobile-flower-badges">
                {flower.qualities.map((quality) => (
                  <div key={quality} className="mobile-flower-quality">
                    {quality}
                  </div>
                ))}
              </div>
            ) : null}
          </div>
          <div className="mobile-flower-yields">
            {SEASONS.map((season) => (
              <div key={season} className="mobile-flower-yield-row">
                <SeasonIcon season={season} inverted={season === currentSeason} />
                {Object.entries(flower.yield_[season] ?? {}).map(([resource, amount]) => (
                  <Fragment key={`${flower.id}-${season}-${resource}`}>
                    <div>{amount}</div>
                    <ResourceIcon resource={resource as 'nectar' | 'pollen' | 'honey' | 'wax'} />
                  </Fragment>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      {pollinatedByColor ? <Worker color={pollinatedByColor} /> : null}
    </div>
  )
}
